// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plc-info[data-v-ccca5e9a]{align-items:flex-start;background:rgba(34,34,34,.5);border-radius:4px;cursor:pointer;display:flex;margin-bottom:12px;padding:4px 6px 4px 4px;width:-moz-fit-content;width:fit-content}.plc-info .plc-icon[data-v-ccca5e9a]{height:20px;width:20px}.plc-info .plc-desc[data-v-ccca5e9a]{color:#fff;font-size:14px;font-weight:500;margin-left:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
